import { Component } from '@angular/core';

@Component({
  selector: 'app-folder-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './folder-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class FolderIconComponent {}
